var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 10",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.26.504a1 1 0 0 1 0 1.415l-7.072 7.07a1 1 0 0 1-1.414 0l-.011-.012-3.525-3.523A1 1 0 0 1 2.653 4.04l2.829 2.828L11.845.504a1 1 0 0 1 1.414 0Z",
  fill: "currentColor"
})));
export default SvgCheckmark;